<template>
  <div>
    <h3 class="student-subaccount-box--title mb-3">
      {{ $t("bookedClasses") }}
    </h3>

    <v-row class="mb-4">
      <v-col cols="6" lg="3">
        <v-menu v-model="showFromPicker" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
          offset-y min-width="290px" max-width="290px">
          <template v-slot:activator="{ on }">
            <v-text-field v-model="date.from_date_time" :label="$t('fromDate')" prepend-icon="mdi-calendar-range"
              v-on="on" clearable @click:clear="() => clearFilter('from_date_time')" color="success"></v-text-field>
          </template>
          <v-date-picker @change="getClasses" color="green lighten-1" v-model="date.from_date_time"
            @input="showFromPicker = false"></v-date-picker>
        </v-menu>
      </v-col>

      <v-col cols="6" lg="3">
        <v-menu v-model="showToPicker" :close-on-content-click="false" :nudge-right="40"
          transition="scale-transition" offset-y min-width="290px" max-width="290px">
          <template v-slot:activator="{ on }">
            <v-text-field v-model="date.to_date_time" :label="$t('toDate')" prepend-icon="mdi-calendar-range"
              v-on="on" clearable @click:clear="() => clearFilter('to_date_time')" :disabled="!date.from_date_time" color="success"></v-text-field>
          </template>
          <v-date-picker @change="getClasses" color="green lighten-1" v-model="date.to_date_time"
            @input="showToPicker = false" :allowed-dates="checkAllowedDates"></v-date-picker>
        </v-menu>
      </v-col>
    </v-row>

    <v-data-table
      :headers="headersTitles"
      :items="upcommingSessions"
      item-key="id"
      class="elevation-1"
      :items-per-page="10"
      :footer-props="tableFooterOptions"
      mobile-breakpoint="992"
    >
      <template v-slot:item.startOnZoom="{ item }">
              <v-btn
                v-if="
                  isSessionTime(item) && (!inMeeting || inMeeting == 'false')
                "
                class="action-btn"
                type="button"
                color="green lighten-1"
                small
                shaped
                @click="joinOnZoom(item.zoom_meeting.zoom_meeting_number)"
              >
                {{ $t("start") }}
              </v-btn>

              <v-btn
                v-else
                disabled
                class="action-btn"
                type="button"
                color="green lighten-1"
                small
                shaped
                @click="joinOnZoom(item.zoom_meeting.zoom_meeting_number)"
              >
                {{ $t("start") }}
              </v-btn>
      </template>
      <template v-slot:item.reschedule="{ item }">
              <v-btn
                v-if="
                  !isSessionTime(item) && item.reservation_type !== 'Group Class'
                "
                class="action-btn"
                type="button"
                color="green lighten-1"
                small
                shaped
                @click="showReScheduleDialog(item)"
              >
                {{ $t("reschedule") }}
              </v-btn>
              <v-btn
                v-else
                disabled
                class="action-btn"
                type="button"
                color="green lighten-1"
                small
                shaped
                @click="showReScheduleDialog(item)"
              >
                {{ $t("reschedule") }}
              </v-btn>
			</template>
    </v-data-table>
    <v-dialog  transition="dialog-bottom-transition"
      max-width="1400"
      v-model="reScheduleDialog"
      v-if="reScheduleDialog">
    <v-card>
				<v-card-title>
					<span class="text-h3">
							{{ $t("rescheduleSession") }}
					</span>
					<v-spacer></v-spacer>
					<v-btn
						class="mx-2 btn-round"
						small
						color="primary"
						@click="hideReScheduleDialog"
					>
						<v-icon dark>
							mdi-window-close
						</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text class="card-content">
          <SessionsView :id="tutorId" :isHelpVisible="false"/>
        </v-card-text>
        <v-card-actions class="actions-btn-group pe-6">
          <v-btn class="action-btn" color="green lighten-1" @click="reSchedule" :disabled="rescheduleRequest">{{ $t("reschedule") }}</v-btn>
          <v-btn class="action-btn" color="red darken-3" @click="hideReScheduleDialog">{{ $t("Cancel") }}</v-btn>
        </v-card-actions>
    </v-card>    
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
import GlobalMixin from "@/GlobalMixin.js";
import SessionsView from "@/views/NewReservation/SessionsView.vue";

export default {
  mixins: [GlobalMixin],
  data() {
    return {
      todayDate: "",
      timeNow: "",
      dataBody: {},
      upcommingSessions: [],
      inMeeting: this.$store.getters.GET_IN_MEETING,

      showFromPicker: false,
      showToPicker: false,
      date: {},

      reScheduleDialog: false,
      tutorId: null,
      studentId: null,
      startDateTime: '',
      endDateTime: '',
      rescheduleRequest:false,

      tableFooterOptions: {
				"items-per-page-options": [10, 20, 30, 40, 50, 100],
				"show-current-page": true,
				showFirstLastPage: true,
				firstIcon: "mdi-arrow-collapse-left",
				lastIcon: "mdi-arrow-collapse-right",
			},

      preferredLanguage : localStorage.getItem('preferred-lang')
    };
  },
  components: {
    SessionsView
  },
  mounted() {
    // this.inMeeting = window.localStorage.getItem("inMeeting");
    // window.addEventListener("storage", () => {
    //   this.inMeeting = window.localStorage.getItem("inMeeting");
    // });
    this.inMeeting = this.$store.getters.GET_IN_MEETING;
  },
  async created() {
    var date = new Date();
    var options = { hour12: false };
    var CurrentTime = date.toLocaleString("en-US", options);
    var time = CurrentTime.split(",")[1].split(":")[0];

    this.todayDate = moment().format("Y-MM-DD");

    if (time == 24) {
      this.timeNow = time - 24;
    } else {
      this.timeNow = CurrentTime.split(",")[1].trim();
    }

    await this.getClasses();
  },
  methods: {
    async getClasses() {
      const {from_date_time, to_date_time} = this.date;
      const body = {
        ...this.dataBody,
      }
      if (from_date_time) body.from_date_time = `${from_date_time} 00:00:00`;
      if (to_date_time) body.to_date_time = `${to_date_time} 00:00:00`;
      let upcomingsUrl = process.env.VUE_APP_APIEndPoint + "reserve/upcomings/";
      let response = await this.axios.post(
        upcomingsUrl,
        body,
        this.headers
      );
      if (response) {
        this.upcommingSessions = response.data.data.upcoming_sessions.map(session => {return {
          ...session,
          day: this.preferredLanguage == "ar" ? 
                this.arabicWeekdayString[moment(session.start_date).format('dddd')] : 
                moment(session.start_date).format('dddd')
        }});
      } else {
        console.log("error while getting tutor current classes....");
      }
    },
    async startZoomMeeting(item) {
      var user = this.$store.getters.StateUser?.user;
      let userId = user.id;
      let uid = btoa(userId.toString());
      let meetingId = item;
      let mid = btoa(meetingId.toString());
      this.$router.push({ name: "meeting", query: { uid: uid, mid: mid } });
    },

    joinOnZoom(item) {
      var user = this.$store.getters.StateUser?.user;
      let userId = user.id;
      let uid = btoa(userId.toString());
      let meetingId = item;
      let mid = btoa(meetingId.toString());
      let data = {
        uid,
        mid,
      };
      this.axios
        .post(
          `${process.env.VUE_APP_APIEndPoint}reserve/meeting/`,
          data,
          this.headers
        )
        .then((response) => {
          if (response) {
            window.open(response.data.data.zoom_meeting.join_meeting_url);
          }
        });
    },
    isSessionTime(item) {
      let startTimestamp = moment(`${item.start_date} ${item.start_time}`)
        // .tz(this.headers.headers["USER-TIMEZONE"])
        .unix();
      let endTimestamp = moment(`${item.end_date} ${item.end_time}`)
        // .tz(this.headers.headers["USER-TIMEZONE"])
        .unix();
      let currentTimestamp = moment(
        `${moment()
          // .tz(this.headers.headers["USER-TIMEZONE"])
          .format("D/M/Y HH:mm:ss")}`,
        "D/M/Y HH:mm:ss"
      ).unix();
      return (
        currentTimestamp >= startTimestamp && currentTimestamp <= endTimestamp
      );
    },
    /**
     * Show reSchedule dialog and assign tutorID,startDateTime and endDateTime
     * @param {*sessionObject} item 
     */
    showReScheduleDialog(item) {
      this.reScheduleDialog = true;
      this.tutorId = item.tutor.id;
      this.studentId = item.student.id;
      this.startDateTime = `${item.start_date} ${item.start_time}`
      this.endDateTime = `${item.end_date} ${item.end_time}`
    },
    hideReScheduleDialog() {
      this.reScheduleDialog = false;
      this.tutorId = null;
      this.studentId = null;
      this.startDateTime = ' ';
      this.endDateTime = ' ';
      this.$store.dispatch("removeSelectedSlot");
    },
    /**
     * Re-schedule Session
     */
    reSchedule() {
      if(!this.$store.getters.GET_SELECTED_SLOTS[0]) {
        return this.showAlert('Please select a slot to re-schedule!', "error");
      }

      this.rescheduleRequest = true;

      const body = {
        tutor: this.tutorId,
        student: this.studentId,
        existing_slot: {
          start_date_time: this.startDateTime,
          end_date_time: this.endDateTime
        },
        requested_slot: {
          start_date_time: this.$store.getters.GET_SELECTED_SLOTS[0].start_date_time,
          end_date_time: this.$store.getters.GET_SELECTED_SLOTS[0].end_date_time
        }
      }

      this.axios
        .post(
          `${process.env.VUE_APP_APIEndPoint}reserve/session/reschedule/`,
          body,
          this.headers
        ).then((res) => {
            this.rescheduleRequest = false;
            this.showAlert(res.data.data.message, "success")
            this.hideReScheduleDialog()
          }
        ).catch(
          (err) => {
            this.formatErrors(err)
            this.rescheduleRequest = false
          }
        );
    },
    checkAllowedDates(date) {
      return date >= this.date.from_date_time;
    },
    clearFilter(type) {
      delete this.date[type];
      this.getClasses();
    },
  },
  computed: {
    headersTitles() {
      return [
        { text: this.$t("reservationNumber"), value: "reservation_id", sortable: false, align:'center' },
        { text: this.$t("course_Type"), value: "course_type", sortable: false, align:'center' },
        { text: this.$t("Start_Date"), value: "start_date", sortable: false, align:'center' },
        { text: this.$t("Start_Time"), value: "start_time", sortable: false, align:'center' },
        { text: this.$t("startDay"), value: "day", sortable: false, align:'center' },
        {
          text: this.$t("programName"),
          value: "program.name",
          sortable: false,
          align:'center'
        },
        { text: this.$t("tutorName"), value: "tutor.full_name", sortable: false, align:'center' },
        { text: this.$t("studentName"), value: "student_name", sortable: false, align:'center' },
        // { text: this.$t("joinClass"), value: "joinClass", sortable: false , align:'center' },
        { text: this.$t("joinClassZoom"), value: "startOnZoom", sortable: false , align:'center' },
        { text: this.$t("reschedule"), value: "reschedule", sortable: false , align:'center' },
      ];
    },
    arabicWeekdayString (){  
      return {
        Saturday: "السبت",
        Sunday: "الأحد",
        Monday: "الأثنين",
        Tuesday: "الثلاثاء",
        Wednesday: "الأربعاء",
        Thursday: "الخميس",
        Friday: "الجمعه",
      }
    }
  },
};
</script>
<style scoped lang="scss">
.btn-round {
  padding: 4px 10px;
}

.disabled-btn,
.disabled-btn:hover {
  background-color: #c0c5be;
}

.action-column {
  display: flex;
  gap: 5px;
}

.card-content{
  margin-top: -2rem;
}

.actions-btn-group{
  display: flex;
  justify-content: center;
  gap: 2rem;
}

.action-btn{
  color: #fff;
}
</style>
